import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { CookieService } from 'ngx-cookie-service';

import {
  // Public
  HomeComponent,
  EntrarComponent,
  DocumentacaoComponent,
  AcessoInternoComponent,
  // Private
  AgendamentoComponent,
  PrimeiroPassoComponent,
  SegundoPassoComponent,
  TerceiroPassoComponent,
  AcompanhamentoComponent,
  ContestacaoComponent
} from '@pages/index';

const routes: Routes = [
  // Public Pages
  { path: '', pathMatch: 'full', component: HomeComponent },
  { path: 'agendar', component: AgendamentoComponent },
  { path: 'entrar', component: EntrarComponent },
  { path: 'documentacao', component: DocumentacaoComponent },
  { path: 'acesso-interno', component: AcessoInternoComponent },

  // Private Pages
  { path: 'recadastramento/primeiro-passo', component: PrimeiroPassoComponent, canActivate: [AuthGuard] },
  { path: 'recadastramento/segundo-passo', component: SegundoPassoComponent, canActivate: [AuthGuard] },
  { path: 'recadastramento/terceiro-passo', component: TerceiroPassoComponent, canActivate: [AuthGuard] },
  { path: 'acompanhamento', component: AcompanhamentoComponent, canActivate: [AuthGuard] },
  { path: 'contestacao', component: ContestacaoComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  providers: [CookieService],
  exports: [RouterModule]
})
export class AppRoutingModule { }
